import Vue from 'vue';
import _ from 'lodash';

jQuery(document).ready(function() {
	window.searchCommonData = {
		pages: [],
		activePages: [],
		searchQuery: '',
		loadingSearch: true,
		searchFocus: false,
		selectedSearchItem: false,
	};

	window.searchCommonMethods = {
		getPages() {
			if (window.profetPreload && window.profetPreload.searchdata) {
				this.pages = window.profetPreload.searchdata;
				this.loadingSearch = false;
				this.convertStringsToInts();
			} else {
				axios.get('/wp-json/nk/getSearchData/').then((response) => {
					this.pages = response.data.data;
					this.loadingSearch = false;
					this.convertStringsToInts();
				});
			}
		},

		changeSelectedSearchTerm(direction) {
			if (direction == 'up') {
				if (this.selectedSearchItem === false) {
					this.selectedSearchItem = 0;
				} else if (this.selectedSearchItem == 0) {
					this.selectedSearchItem = this.activePages.length - 1;
				} else {
					this.selectedSearchItem = this.selectedSearchItem - 1;
				}
			}
			if (direction == 'down') {
				if (this.selectedSearchItem >= this.activePages.length - 1) {
					this.selectedSearchItem = 0;
				} else if (this.selectedSearchItem === false) {
					this.selectedSearchItem = 0;
				} else {
					this.selectedSearchItem = this.selectedSearchItem + 1;
				}
			}
		},

		convertStringsToInts() {
			for (var page in this.pages) {
				/* Set the search_points to an integer */
				this.pages[page].search_points = parseInt(this.pages[page].search_points, 10);

				/* Set all the search_points on the indications to integers */
				for (var indication in this.pages[page].indications) {
					this.pages[page].indications[indication].search_points = parseInt(this.pages[page].indications[indication].search_points, 10);
				}
			}
		},

		hideSearch(event) {
			var self = this;

			setTimeout(function() {
				self.searchFocus = false;
			}, 200);
		},

		orderSearchResultsByPoints() {
			/* Order active search results by calculatedSearchPoints */
			this.activePages = _.sortBy(this.activePages, (o) => o.calculatedSearchPoints).reverse();
		},

		goToSelectedSearchTerm() {
			event.preventDefault();
			var ref = this.$refs['search-term-' + this.selectedSearchItem];
			ref[0].click();
		},

		doSearch(event) {
			/* If it's a up arrow or down arrow key press, don't make a new search */
			if (event.which == 38 || event.which == 40) {
				return;
			}

			this.selectedSearchItem = false;

			this.activePages = [];
			var query = this.searchQuery.toLowerCase();

			if (this.searchQuery.length > 1) {
				for (var page in this.pages) {
					var multiplier = 1;

					var pushToActive = false;
					/* Set the search score to 0 by default */
					this.pages[page].calculatedSearchPoints = 0;
					var pageTitle = this.pages[page].title.toLowerCase();

					/*if(pageTitle.indexOf(query) !== -1) {*/
					if (pageTitle.indexOf(query) !== -1) {
						pushToActive = true;

						if (pageTitle.substring(0, query.length) == query) {
							/* If the search matches the full starting characters of the page title, and the page has less than 100 search points, set the search points to 100 to automatically float the result high up */
							if (this.pages[page].calculatedSearchPoints < 100) {
								this.pages[page].calculatedSearchPoints = 100;
							}

							multiplier *= 1.8;
						}

						/* If the search matches exactly, give 200 search points */
						if (pageTitle == query) {
							multiplier = 2;
						}

						/* Add points based on how many percent of the title the search query matches */
						if (pageTitle.substring(0, query.length) == query) {
							var percentageMatch = query.length / pageTitle.length;
							percentageMatch *= 100;
							percentageMatch = Math.round(percentageMatch);
							this.pages[page].calculatedSearchPoints += percentageMatch;
						}

						var splitString = pageTitle.split(' ');
						for (var s in splitString) {
							if (splitString[s].substring(0, query.length) == query) {
								if (multiplier == 1) {
									multiplier *= 1.3;
								}
							}
						}

						if (this.pages[page].search_points > this.pages[page].calculatedSearchPoints) {
							this.pages[page].calculatedSearchPoints = this.pages[page].search_points;
						}
					}

					/* Check if any of the search tags match */
					if (this.pages[page].search_tags != undefined) {
						for (var tag in this.pages[page].search_tags) {
							var searchTag = this.pages[page].search_tags[tag].name.toLowerCase();
							/*if(searchTag.indexOf(query) !== -1) {*/
							if (searchTag.substring(0, query.length) == query) {
								pushToActive = true;
								if (this.pages[page].search_tags[tag].search_points > this.pages[page].calculatedSearchPoints) {
									this.pages[page].calculatedSearchPoints = this.pages[page].search_tags[tag].search_points;

									if (multiplier != 1) {
										multiplier = 1.1;
									}
								}
							}
						}
					}

					/* Check if any of the indications match */
					if (this.pages[page].indications != undefined) {
						for (var indication in this.pages[page].indications) {
							var indicationName = this.pages[page].indications[indication].name.toLowerCase();
							/*if(indicationName.indexOf(query) !== -1) {*/
							if (indicationName.substring(0, query.length) == query) {
								pushToActive = true;
								if (this.pages[page].indications[indication].search_points > this.pages[page].calculatedSearchPoints) {
									this.pages[page].calculatedSearchPoints = this.pages[page].indications[indication].search_points;
								}
							}
						}
					}

					/* Lower score for anything that isn't a page */
					if (this.pages[page].post_type == 'post') {
						//pushToActive = false;
						multiplier *= 0.95;
					}

					if (pushToActive) {
						if (this.pages[page].calculatedSearchPoints < 20 && multiplier > 1.3) {
							this.pages[page].calculatedSearchPoints = 50;
						}

						this.pages[page].calculatedSearchPoints *= multiplier;
						this.activePages.push(this.pages[page]);
					}
				}

				this.orderSearchResultsByPoints();
			}
		},
	};

	new Vue({
		el: '#header-desktop',

		data: window.searchCommonData,

		methods: window.searchCommonMethods,

		computed: {
			showPopularSearches() {
				if (this.searchFocus == true && this.searchQuery.length == 0 && this.activePages.length == 0) {
					return true;
				}
				return false;
			},
			searchIsActive() {
				if (this.searchQuery.length > 0 || this.searchFocus) {
					return true;
				}
				return false;
			},
		},

		created() {
			this.getPages();

			/* Set up keyboard binding */
			document.onkeydown = (e) => {
				switch (e.keyCode) {
					case 13:
						this.goToSelectedSearchTerm();
						break;
					case 38:
						this.changeSelectedSearchTerm('up');
						break;
					case 40:
						this.changeSelectedSearchTerm('down');
						break;
				}
			};
		},
	});

	new Vue({
		el: '#header-mobile',

		data: window.searchCommonData,

		computed: {
			showPopularSearches() {
				if (this.searchFocus == true && this.searchQuery.length == 0 && this.activePages.length == 0) {
					return true;
				}
				return false;
			},
			searchIsActive() {
				if (this.searchFocus) {
					return true;
				}
				return false;
			},
		},

		methods: window.searchCommonMethods,
	});
});
